import React from "react";
import '../../../../styles/component/employee-details/section-card.scss';

interface Props {
    icon?: React.ReactNode;
    title: string;
    extra?: React.ReactNode;
    children: React.ReactNode;
    tag?: string;
    subHeading?: string;
}

const SectionCard = ({icon, title, tag, extra, children, subHeading}: Props) => {
    return (
        <div className="section-card">
            <div className="section-card__header">
                <div className="left">
                    <div>
                        {icon && <div className="icon">{icon}</div>}
                    </div>
                    <div className={'title-and-tag'}>
                        <h3>{title}</h3>
                        {tag && <p className={'sub-tag'}>{tag}</p>}
                        {subHeading && <h5>{subHeading} </h5>}
                    </div>

                </div>
                {extra && <div className="employee-detail-edit-icon">{extra}</div>}
            </div>

            <div className="section-card__body">
                {children}
            </div>
        </div>
    );
};

export default SectionCard;
